import HighResImages from "./highResImages";

export default HighResImages;